import { CSSObject } from "@emotion/react";

import { typographyStyles, constants } from "@newsela/angelou";
import { partialCtaDefaultLinearGradientBackground } from "../AiComponents.style";

import { gradientBackgrounds } from "../AiComponents.style";

const { colors } = constants;
const { ui } = colors;
const { textMObj } = typographyStyles;
const { fontSize, fontFamily } = textMObj;

export const rootContainerCss = (
  expanded: boolean,
  isMobile: boolean = false,
): CSSObject => ({
  position: "relative",
  width: "270px",

  ...(expanded
    ? {
        ...(isMobile
          ? {
              width: "inherit",
              height: 0,
            }
          : {}),
      }
    : {}),
});

export const innerBorderCss = (
  expanded: boolean,
  isMobile: boolean = false,
): CSSObject => ({
  position: "relative",
  padding: "1px",
  borderRadius: "10px",
  backgroundImage:
    "linear-gradient(279.44deg, #691C9C 4.6%, #1F3CD7 66.61%, #1088EB 100%)",
  backgroundOrigin: "border-box",
  transition: "transform 0.5s ease",

  ...(expanded
    ? {
        width: "480px",
        zIndex: 100,
        top: isMobile ? 64 : 120,
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        transform: "translate(0.5%, 0) scale(1)",

        ...(isMobile
          ? {
              width: "inherit",
              borderRadius: "0 0 10px 10px",
              transform: "none",
            }
          : {}),
      }
    : {}),
});

export const innerContentCss = (expanded: boolean): CSSObject => ({
  position: "relative",
  background: gradientBackgrounds[100],
  borderRadius: "inherit",
  padding: expanded ? "12px" : "2px 6px",
  display: "flex",
  alignItems: "center",
  flex: 1,
  flexDirection: expanded ? "column" : "row",
  gap: expanded ? 12 : 0,
  width: "100%",

  // Adds full width to all its immediate child divs
  // so they can all be aligned equally. The toggle
  // with track event also prevents us from styling
  // the root div so this also solves for that.
  "> div": {
    width: "100%",
  },
});

export const headingSectionExpandedCss: CSSObject = {
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: 4,
  padding: "4px 0",
};

export const textAreaRootContainerCss = (expanded: boolean): CSSObject => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",

  ...(expanded
    ? {
        width: "100%",
        // The following styles create the border around the textarea.
        // To achieve a gradient as a "border", we apply it as a background
        // and adjust padding and radius on here and on the textarea.
        borderRadius: "6px",
        padding: "2px",
        ...partialCtaDefaultLinearGradientBackground,
      }
    : {}),
});

export const labelTextCss: CSSObject = {
  width: 0,
  height: 0,
  margin: 0,
  overflow: "hidden",
};

export const textAreaCss = (expanded: boolean): CSSObject => ({
  fontFamily,
  fontSize,
  color: ui.neutral[700],
  whiteSpace: expanded ? "normal" : "nowrap",
  resize: "none",
  width: "220px",
  borderRadius: "5px",
  overflow: "hidden",
  border: "none",
  padding: "10px 1px",
  ...(!expanded && { paddingLeft: "4px" }),
  transition: "minWidth 0.5s ease",

  ...(expanded
    ? {
        width: "100%",
        borderRadius: "4px",
        padding: "10px",
      }
    : {}),

  ":hover": {
    border: "none",
  },
  ":focus-visible": {
    outline: "none",
  },
  "::placeholder": {
    paddingLeft: "6px",
    color: ui.neutral[500],
  },
});

export const svgCss: CSSObject = {
  width: "36px",
  height: "34px",
};

export const toggleSwitchContainerCss: CSSObject = {
  ...partialCtaDefaultLinearGradientBackground,
};
